import React from 'react';

const HalfDonutChart = ({ value, max, width, height, thickness }) => {
    // Calculate the radius of the outer circle
    const radius = (Math.min(width, height) / 2) - thickness;
    const centerX = width / 2;
    const centerY = height / 2;
  
    // Calculate the circumference of the full circle and half circle
    const circumference = 2 * Math.PI * radius;
    const halfCircumference = circumference / 2;
  
    // Calculate the stroke dash offset
    const progress = Math.min(value / max, 1); // Ensure value is not greater than max
    const strokeDashOffset = halfCircumference * (1 - progress);
  
    return (
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height / 2}`}>
        {/* Background semi-circle */}
        <path
          d={`
            M ${centerX - radius},${centerY}
            A ${radius},${radius} 0 1,1 ${centerX + radius},${centerY}
          `}
          fill="none"
          stroke="#ff4d4b"
          strokeWidth={thickness}
        />
  
        {/* Foreground semi-circle (progress) */}
        <path
          d={`
            M ${centerX - radius},${centerY}
            A ${radius},${radius} 0 1,1 ${centerX + radius},${centerY}
          `}
          fill="none"
          stroke="#6ce36d"
          strokeWidth={thickness}
          strokeDasharray={halfCircumference}
          strokeDashoffset={strokeDashOffset}
        //   strokeLinecap="round"
        />
      </svg>
    );
  };

export default HalfDonutChart;
